module.exports = __webpack_public_path__ + "img/icon_map_71_off.f5583675.png";